/**
 * Action types.
 */
export const RECEIVE_TEMPLATE_VARIABLES = 'receive_template_variables';

/**
 * Reducer function. Accepts a state and an action, and returns the modified
 * state depending on the action type. If no matching action types are found,
 * returns the unmodified state.
 *
 * @param {object} state - The state to modify or return.
 * @param {object} action - The action type to analyze.
 * @returns {object} - The new state value.
 */
export default function reducer(state = {}, action) {
  switch (action.type) {
    case RECEIVE_TEMPLATE_VARIABLES:
      return action.variables;

    default:
      return state;
  }
}

/**
 * Fires when receiving updated template variables for the page.
 *
 * @param variables
 * @returns {{variables: {}, type: string}}
 */
export function receiveTemplateVariables(variables = {}) {
  return {
    type: RECEIVE_TEMPLATE_VARIABLES,
    variables,
  };
}

/**
 * Thunk for getting the current template variables.
 */
export function updateTemplateVariables() {
  const { root } = window.nsApiSettings;

  /**
   * Note that in effect we are requesting the variables for the home page no
   * matter what page is being viewed. This works in practice because the only
   * data currently needed are sitewide variables, and it allows the same cached
   * endpoint to be used across the site. In the future, the path requested here
   * could include the page-specific query vars to get the template variables
   * specific to the current page instead of always the home page variables. Or,
   * the store could contain separate keys for sitewide and page-specific
   * template variables built from two API requests.
   */
  return (dispatch) => fetch(`${root}lakana/v1/template-variables/`)
    .then((response) => {
      if (! response.ok) {
        throw new Error('Network response not ok');
      }

      return response.json();
    })
    .then((json) => dispatch(receiveTemplateVariables(json)))
    .catch(() => {
    } /* silence */);
}

